import { drama } from '../../constants/actionTypes';

export default (state = {}, { type, payload }) => {
  switch (type) {
    case drama.FETCH_DRAMA_SUMMARY_SUCCESS:
      return payload.entities.dramas;

    default:
      return state;
  }
};
